module.exports = __webpack_public_path__ + "static/media/clubs-king.954d4900.png";